import { render } from "./PersonalList.vue?vue&type=template&id=70982d6e"
import script from "./PersonalList.vue?vue&type=script&lang=js"
export * from "./PersonalList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__